export default {
	apiKey: "AIzaSyCGJtEfOcN--f3Q_X61QO2ercgCAMdBA70",
	authDomain: "attitude-io.firebaseapp.com",
	databaseURL: "https://attitude-io.firebaseio.com",
	projectId: "attitude-io",
	storageBucket: "attitude-io.appspot.com",
	messagingSenderId: "1069063951078"
};